export const validationRules = (formData) => ({
  // PersonalDetails
  firstName: {
    required: true,
    pattern: /^[A-Za-z ]+$/,
    message: "First name must contain only letters",
  },
  lastName: {
    required: true,
    pattern: /^[A-Za-z ]+$/,
    message: "Last name must contain only letters",
  },
  preferredName: {
    required: true,
    validate: (value) => {
      if (!value) return true;
      if (/\s/.test(value)) {
        return "No spaces allowed";
      }
      if (!/^[A-Za-z]*$/.test(value)) {
        return "Preferred Name must contain only letters";
      }
      return true;
    },
  },
  gender: { required: true },
  email: {
    required: true,
    pattern: /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    message: "Enter a valid email (e.g., user@example.com)",
  },
  phone: {
    required: true,
    pattern: /^\d{10}$/,
    message: "Phone must be 10 digits",
  },
  address: { required: true },
  city: {
    required: true,
    pattern: /^[\p{L}\p{M}\s.,&()'/-]+$/u,
    message: "City must contain only letters",
  },
  state: {
    required: true,
    pattern: /^[\p{L}\p{M}\s.,&()'/-]+$/u,
    message: "State must contain only letters",
  },
  zip: { required: true },
  country: {
    required: true,
    pattern: /^[\p{L}\p{M}\s.,&()'/-]+$/u,
    message: "Country must contain only letters",
  },
  conferenceMissionUnion: { required: true },
  addressConfirmation: { required: true },

  // Travel Details
  citizenship: {
    required: true,
    pattern: /^[A-Za-z ]+$/,
    message: "Country must contain only letters",
  },

  file: {
    required: formData.noPassport === "Yes" ? false : true,
    message: "Passport scan is required",
  },
  passportNo: {
    required: formData.noPassport === "Yes" ? false : true,
    minLength: {
      value: 9,
      message: "Passport number must be 9 characters",
    },
    maxLength: {
      value: 9,
      message: "Passport number must be 9 characters",
    },
  },
  passportExp: {
    required: formData.noPassport === "Yes" ? false : true,
    message: "Passport expiry is required",
  },
  dob: {
    required: true,
    validate: (val) => {
      if (!val) return "DOB is required.";

      const inputDate = new Date(val);
      const today = new Date();

      // Normalize both to remove time
      const inputDateOnly = new Date(
        inputDate.getFullYear(),
        inputDate.getMonth(),
        inputDate.getDate()
      );
      const todayOnly = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );

      if (inputDateOnly > todayOnly) {
        return "DOB cannot be in the future.";
      }

      return true;
    },
  },
  passportConfirmation: { required: true },

  // Translation & Volunteering
  willingToLeadGroup: { required: true },
  languagesSpoken:
    formData.willingToLeadGroup === "yes"
      ? { required: true }
      : { required: false },
  tshirtSize: { required: true },

  photographicConsent: { required: true },
  agreeTermsConditions: {
    validate: (value) =>
      value === "yes" ||
      "You must agree to the data processing and conduct agreement",
  },
});
